import closeIcon from "@assets/img/close.svg";

const InvestorModal = ({
  closeModal,
  text = "Раздел находится в разработке. Совсем скоро будет доступен!",
}) => {
  return (
    <div className="productCard-modal">
      <div
        className="lesson-modal-content investor-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <p className={`lesson-modal-content__text`}>{text}</p>
        <img
          onClick={() => {
            console.log("clicked");
            closeModal();
          }}
          className="productCard-modal__close"
          src={closeIcon}
          width={36}
          height={36}
          alt="close-icon"
        />
      </div>
    </div>
  );
};

export default InvestorModal;
